<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="surveyResponseList"
	[loading]="!surveyResponseList"
	[globalFilterFields]="app.keys(surveyResponseList)"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="survey.name">
				<div class="d-flex w-100">
					Survey Name
					<p-sortIcon field="survey.name"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="survey.name" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="contactInformation.lastName">
				<div class="d-flex w-100">
					Guest Name (Last Name, First Name)
					<p-sortIcon field="contactInformation.lastName"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="contactInformation.lastName" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="created">
				<div class="d-flex w-100">
					Survey Date
					<p-sortIcon field="creat"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="date" field="created" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="check.checkNumber">
				<div class="d-flex w-100">
					Check # (Table)
					<p-sortIcon field="check.checkNumber"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="number" field="check.checkNumber" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="selectSurvey(rec)">
			<td>{{ rec.survey.name }}</td>
			<td>{{ app.references.toTitleCase(rec.contactInformation.lastName) }}, {{ app.references.toTitleCase(rec.contactInformation.firstName) }}</td>
			<td>{{ app.moment(rec.created).format("L LT") }}</td>
			<td>{{ rec.check.checkNumber }} ({{ rec.check.table }})</td>
		</tr>
	</ng-template>
</p-table>
